import { encodeValue, encryptData } from "./crypto";

export const saveToken = (token: string) => {
  const tokenname = encodeValue("token");
  localStorage.setItem(tokenname, encryptData(token));
  return true;
};

export const isLoggedin = () => {
  const tokenname = encodeValue("token");
  const token = localStorage.getItem(tokenname);
  if (token) return true;
  return false;
};

export const removeToken = () => {
  const tokenname = encodeValue("token");
  localStorage.removeItem(tokenname);
  return true;
};
